import SupportTickets from "@/API/shared/SupportTickets.js"

import LoadingMixin from "@/mixins/loading.js"
import SystemMixin from "@/mixins/system.js"
import HandleRequestErrorsMixin from "@/mixins/handle_request_errors.js"

import ValidationMixin from "@/mixins/validation.js"
import {email, minLength, required, sameAs} from "@vuelidate/validators"

import {sync} from "vuex-pathify"

export default {
    mixins: [LoadingMixin, SystemMixin, HandleRequestErrorsMixin, ValidationMixin],
    computed: {
        ...sync('SupportTickets', ['form'])
    },
    validations: {
        form: {
            shipment: { },
            support_subject_id: {
                required
            },
            body: {
                required
            }
        }
    },
    methods: {
        /**
         * Action
         * @returns {boolean}
         */
        validate() {
            this.v$.$touch()

            console.debug('SupportTicket/Form@validade: Data validated.')

            return !this.v$.$invalid
        },
        /**
         * Dados enviados na criação do chamado
         * A remessa é selecionada na busca, então mandamos o vínculo (shipment_id)
         * no lugar do objeto carregado no formulário.
         * @returns {Object}
         */
        payload() {

            const payload = copy_obj(this.form)

            const shipment_id = payload.shipment?.id ?? null

            delete payload.shipment

            if (filled(shipment_id)) payload.shipment_id = shipment_id

            return payload
        },
        /**
         * Action save
         * @returns {Promise<boolean>}
         */
        async save() {
            if (!this.validate()) return false

            const data = object_to_formdata(this.payload(), {indices: true})

            console.debug('SupportTicket/Form@save: Saving data.', data)

            this.loading()

            const [err, res] = await SupportTickets.insert(data)

            this.loaded()

            if (err) {
                console.error('SupportTicket/Form@save: Error on save data!', err)
                return this.$alertError(this.handleRequestError(err))
            }

            this.form = res.data.data

            console.debug('SupportTicket/Form@save: Data saved!')

            return true
        },
        /**
         * INIT
         */
        init(){
            // O form vem do store e sobrevive entre as telas de chamado, então descartamos
            // a remessa herdada. Reatribuímos o objeto inteiro de propósito: se a chave não
            // existir no form em uso, atribuir direto não seria reativo (Vue 2) e o campo
            // não exibiria a remessa selecionada.
            this.form = {...this.form, shipment: null}
        }
    }
}
